import * as React from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function OurServices() {
  return <section id="our-services" className="relative flex min-h-[80vh] w-full items-center justify-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585014/img/fivestar_roofline_services_hero.png')] bg-cover bg-center bg-no-repeat bg-fixed" />
      
      {}
      <div className="absolute inset-0 bg-black/75" />

      {}
      <div className="relative z-10 mx-auto flex max-w-4xl flex-col items-center px-4 text-center">
        <h1 className="mb-6 font-serif text-5xl font-bold leading-tight tracking-[-0.02em] text-white drop-shadow-xl md:text-[4.5rem]">
          What We Offer
        </h1>
        
        <p className="mb-12 max-w-2xl text-lg font-light leading-relaxed text-white/90 md:text-xl">
          From full uPVC roofline replacements to high-performance{" "}
          <span className="font-medium text-primary drop-shadow-sm">
            EPDM rubber roofing
          </span>, we provide durable solutions tailored for North East homes.
        </p>

        {}
        <Button asChild size="lg" className="group relative h-auto overflow-hidden rounded-lg border border-primary/50 bg-gradient-to-b from-primary/90 to-primary px-8 py-4 text-lg font-semibold text-primary-foreground transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(var(--color-primary),0.5)]">
          <Link to="/GalleryPage">
            <span className="relative z-10 flex items-center gap-2">
              Explore Our Expertise
              <ChevronDown className="size-5 animate-bounce" />
            </span>
            
            {}
            <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-20deg] transition-transform duration-1000 ease-in-out group-hover:translate-x-[200%]" />
          </Link>
        </Button>
      </div>
    </section>;
}